(() => {
  'use strict';
  const dialogs = [
    { id: 'studio-search', open: '[data-search-open]', close: '[data-search-close]' },
    { id: 'studio-menu', open: '[data-menu-open]', close: '[data-menu-close]' }
  ];
  dialogs.forEach(({ id, open, close }) => {
    let opener;
    const dialog = document.getElementById(id);
    if (!dialog) return;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(open);
      if (trigger) {
        event.preventDefault();
        opener = trigger;
        document.querySelectorAll('dialog[open]').forEach(other => other.close());
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        if (id === 'studio-search') dialog.querySelector('input[type=search]')?.focus();
      }
      if (event.target.closest(close)) dialog.close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      opener?.setAttribute('aria-expanded', 'false');
      opener?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.shop-menu[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.shop-menu[open]').forEach(menu => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });
  document.querySelectorAll('[data-sort-form] select').forEach(select => {
    select.addEventListener('change', () => select.form.requestSubmit());
  });
})();
